import { ReactElement } from 'react';
import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/es/checkbox';

export const CheckboxGroup = (props: CheckboxGroupProps): ReactElement => <Checkbox.Group {...props} />;
